import ReactDOM from "react-dom/client";
import "./index.css";
import React, { useState, useEffect, Suspense } from "react";
import Stack from "@mui/system/Stack";
import Box from "@mui/system/Box";
import { height, width } from "@mui/system";

function LoadingScreen({ progress, isLoading }) {
  return (
    <div
      style={{
        position: "relative",
        zIndex: 99,
        overflow: "hidden",
        top: "0px",
        left: "0px",
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        backgroundColor: "rgba(0, 0, 0, 0.8)", // Optional background
        color: "white", // Optional text color
        fontSize: "2em",
      }}
    >
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={4096}
          height={4096}
          viewBox="0 0 4096 4096"
          fill="none"
        >
          <rect
            x="0.5"
            y="0.5"
            width="4095.57"
            height="4095.57"
            fill="#1f1f1f"
            stroke="black"
          />
          <path d="M1868.29 1988H1952.97" stroke="white" strokeWidth={10} />
          <path d="M1868.29 2035.09H1952.97" stroke="white" strokeWidth={10} />
          <path d="M1868.29 2090.18H1952.97" stroke="white" strokeWidth={10} />
          <path d="M1967.81 1988H2052.48" stroke="#5D79FF" strokeWidth={10} />
          <path
            d="M1967.81 2035.09H2052.48"
            stroke="#5D79FF"
            strokeWidth={10}
          />
          <path
            d="M1972.81 2094.97V2036.09"
            stroke="#5D79FF"
            strokeWidth={10}
          />
          <path d="M1873.3 2086.72V2036.64" stroke="white" strokeWidth={10} />
          <path
            d="M2075.16 2092.97V1977.86"
            stroke="#7ED957"
            strokeWidth={10}
          />
          <path d="M2075.16 2094.98V2005.48" stroke="white" strokeWidth={10} />
          <path
            d="M2219.38 2097.68L2183.17 2064.03"
            stroke="#7ED957"
            strokeWidth={10}
          />
          <path
            d="M2048.69 2021.86L2091.74 1989.6"
            stroke="#1F1F1F"
            strokeWidth={10}
          />
          <path
            d="M1943.27 2001.47L1986.33 1969.21"
            stroke="#1F1F1F"
            strokeWidth={10}
          />
          <path
            d="M1851.77 1995.8L1894.82 1963.53"
            stroke="#1F1F1F"
            strokeWidth={10}
          />
          <path
            d="M2040.02 2004.13L2083.06 1971.87"
            stroke="#1F1F1F"
            strokeWidth={10}
          />
          <path
            d="M1846.77 2050.4L1889.81 2018.14"
            stroke="#1F1F1F"
            strokeWidth={10}
          />
          <path
            d="M1963.77 2036.64L1980.92 2024.88"
            stroke="#1F1F1F"
            strokeWidth={10}
          />
          <path
            d="M2195.8 2092.96L2211.92 2074.32"
            stroke="#1F1F1F"
            strokeWidth={6}
          />
          <path
            d="M2203.86 2102.28L2219.98 2083.64"
            stroke="#1F1F1F"
            strokeWidth={6}
          />
          <mask
            id="mask1_1_70"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x={2098}
            y={1984}
            width={106}
            height={106}
          >
            <path
              d="M2151.41 1984.2C2122.44 1984.2 2098.97 2007.68 2098.97 2036.64C2098.97 2065.61 2122.44 2089.09 2151.41 2089.09C2180.37 2089.09 2203.86 2065.61 2203.86 2036.64C2203.86 2007.68 2180.37 1984.2 2151.41 1984.2Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_1_70)">
            <path
              d="M2151.41 1984.2C2122.44 1984.2 2098.97 2007.68 2098.97 2036.64C2098.97 2065.61 2122.44 2089.09 2151.41 2089.09C2180.37 2089.09 2203.86 2065.61 2203.86 2036.64C2203.86 2007.68 2180.37 1984.2 2151.41 1984.2Z"
              stroke="#fff"
              strokeWidth={20}
            />
          </g>
          <path
            d="M1973.3 2120.28C1972.74 2120.28 1972.22 2120.15 1971.75 2119.88C1971.3 2119.61 1970.93 2119.24 1970.65 2118.78C1970.38 2118.31 1970.25 2117.8 1970.25 2117.24V2105.05C1970.25 2104.5 1970.38 2103.99 1970.65 2103.53C1970.93 2103.06 1971.3 2102.69 1971.75 2102.42C1972.22 2102.15 1972.74 2102.01 1973.3 2102.01H1985.49C1986.04 2102.01 1986.55 2102.15 1987.01 2102.42C1987.48 2102.69 1987.85 2103.06 1988.11 2103.53C1988.39 2103.99 1988.53 2104.5 1988.53 2105.05V2117.24C1988.53 2117.8 1988.39 2118.31 1988.11 2118.78C1987.85 2119.24 1987.48 2119.61 1987.01 2119.88C1986.55 2120.15 1986.04 2120.28 1985.49 2120.28H1973.3ZM1973.3 2118.22H1985.49C1985.75 2118.22 1985.98 2118.12 1986.17 2117.93C1986.37 2117.73 1986.47 2117.5 1986.47 2117.24V2105.05C1986.47 2104.79 1986.37 2104.56 1986.17 2104.36C1985.98 2104.17 1985.75 2104.07 1985.49 2104.07H1973.3C1973.02 2104.07 1972.78 2104.17 1972.59 2104.36C1972.39 2104.56 1972.3 2104.79 1972.3 2105.05V2117.24C1972.3 2117.5 1972.39 2117.73 1972.59 2117.93C1972.78 2118.12 1973.02 2118.22 1973.3 2118.22Z"
            fill="white"
          />
          <path
            d="M1940.59 2120.28C1940.03 2120.28 1939.51 2120.15 1939.05 2119.88C1938.59 2119.61 1938.22 2119.24 1937.94 2118.78C1937.68 2118.31 1937.55 2117.8 1937.55 2117.24V2116.53H1939.61V2117.24C1939.61 2117.5 1939.7 2117.73 1939.9 2117.93C1940.09 2118.12 1940.32 2118.22 1940.59 2118.22H1952.78C1953.04 2118.22 1953.27 2118.12 1953.46 2117.93C1953.66 2117.73 1953.76 2117.5 1953.76 2117.24V2113.15C1953.76 2112.88 1953.66 2112.65 1953.46 2112.47C1953.27 2112.27 1953.04 2112.18 1952.78 2112.18H1940.59C1940.03 2112.18 1939.51 2112.04 1939.05 2111.76C1938.59 2111.48 1938.22 2111.11 1937.94 2110.65C1937.68 2110.2 1937.55 2109.69 1937.55 2109.13V2105.05C1937.55 2104.5 1937.68 2103.99 1937.94 2103.53C1938.22 2103.06 1938.59 2102.69 1939.05 2102.42C1939.51 2102.15 1940.03 2102.01 1940.59 2102.01H1952.78C1953.33 2102.01 1953.84 2102.15 1954.3 2102.42C1954.77 2102.69 1955.14 2103.06 1955.4 2103.53C1955.68 2103.99 1955.82 2104.5 1955.82 2105.05V2105.76H1953.76V2105.05C1953.76 2104.79 1953.66 2104.56 1953.46 2104.36C1953.27 2104.17 1953.04 2104.07 1952.78 2104.07H1940.59C1940.32 2104.07 1940.09 2104.17 1939.9 2104.36C1939.7 2104.56 1939.61 2104.79 1939.61 2105.05V2109.13C1939.61 2109.41 1939.7 2109.65 1939.9 2109.84C1940.09 2110.02 1940.32 2110.11 1940.59 2110.11H1952.78C1953.33 2110.11 1953.84 2110.25 1954.3 2110.53C1954.77 2110.81 1955.14 2111.18 1955.4 2111.63C1955.68 2112.09 1955.82 2112.6 1955.82 2113.15V2117.24C1955.82 2117.8 1955.68 2118.31 1955.4 2118.78C1955.14 2119.24 1954.77 2119.61 1954.3 2119.88C1953.84 2120.15 1953.33 2120.28 1952.78 2120.28H1940.59Z"
            fill="white"
          />
          <path
            d="M2037.61 2120.28C2037.05 2120.28 2036.54 2120.15 2036.07 2119.88C2035.61 2119.61 2035.24 2119.24 2034.96 2118.78C2034.7 2118.31 2034.57 2117.8 2034.57 2117.24V2102.01H2036.61V2117.24C2036.61 2117.5 2036.7 2117.73 2036.9 2117.93C2037.09 2118.12 2037.33 2118.22 2037.61 2118.22H2049.8C2050.06 2118.22 2050.29 2118.12 2050.49 2117.93C2050.68 2117.73 2050.78 2117.5 2050.78 2117.24V2102.01H2052.84V2117.24C2052.84 2117.8 2052.7 2118.31 2052.42 2118.78C2052.16 2119.24 2051.79 2119.61 2051.32 2119.88C2050.86 2120.15 2050.35 2120.28 2049.8 2120.28H2037.61Z"
            fill="white"
          />
          <path
            d="M2003.1 2120.28V2101.99H2005.16V2118.22H2021.37V2120.28H2003.1Z"
            fill="white"
          />
          <path
            d="M2184.2 2120.28C2183.64 2120.28 2183.12 2120.15 2182.65 2119.88C2182.2 2119.61 2181.83 2119.24 2181.55 2118.78C2181.28 2118.31 2181.15 2117.8 2181.15 2117.24V2116.53H2183.22V2117.24C2183.22 2117.5 2183.31 2117.73 2183.51 2117.93C2183.7 2118.12 2183.93 2118.22 2184.2 2118.22H2196.39C2196.65 2118.22 2196.87 2118.12 2197.07 2117.93C2197.27 2117.73 2197.36 2117.5 2197.36 2117.24V2113.15C2197.36 2112.88 2197.27 2112.65 2197.07 2112.47C2196.87 2112.27 2196.65 2112.18 2196.39 2112.18H2184.2C2183.64 2112.18 2183.12 2112.04 2182.65 2111.76C2182.2 2111.48 2181.83 2111.11 2181.55 2110.65C2181.28 2110.2 2181.15 2109.69 2181.15 2109.13V2105.05C2181.15 2104.5 2181.28 2103.99 2181.55 2103.53C2181.83 2103.06 2182.2 2102.69 2182.65 2102.42C2183.12 2102.15 2183.64 2102.01 2184.2 2102.01H2196.39C2196.94 2102.01 2197.45 2102.15 2197.91 2102.42C2198.38 2102.69 2198.75 2103.06 2199.01 2103.53C2199.29 2103.99 2199.43 2104.5 2199.43 2105.05V2105.76H2197.36V2105.05C2197.36 2104.79 2197.27 2104.56 2197.07 2104.36C2196.87 2104.17 2196.65 2104.07 2196.39 2104.07H2184.2C2183.93 2104.07 2183.7 2104.17 2183.51 2104.36C2183.31 2104.56 2183.22 2104.79 2183.22 2105.05V2109.13C2183.22 2109.41 2183.31 2109.65 2183.51 2109.84C2183.7 2110.02 2183.93 2110.11 2184.2 2110.11H2196.39C2196.94 2110.11 2197.45 2110.25 2197.91 2110.53C2198.38 2110.81 2198.75 2111.18 2199.01 2111.63C2199.29 2112.09 2199.43 2112.6 2199.43 2113.15V2117.24C2199.43 2117.8 2199.29 2118.31 2199.01 2118.78C2198.75 2119.24 2198.38 2119.61 2197.91 2119.88C2197.45 2120.15 2196.94 2120.28 2196.39 2120.28H2184.2Z"
            fill="white"
          />
          <path
            d="M2074.6 2120.28V2104.07H2066.47V2102.01H2084.74V2104.07H2076.66V2120.28H2074.6Z"
            fill="white"
          />
          <path
            d="M2148.4 2120.28V2102.01H2151.21L2164.63 2117.95V2102.01H2166.67V2120.28H2163.86L2150.46 2104.34V2120.28H2148.4Z"
            fill="white"
          />
          <path
            d="M2098.67 2120.28V2102.01H2100.75V2120.28H2098.67Z"
            fill="white"
          />
          <path
            d="M2118.62 2120.28C2118.06 2120.28 2117.55 2120.15 2117.08 2119.88C2116.62 2119.61 2116.25 2119.24 2115.98 2118.78C2115.71 2118.31 2115.58 2117.8 2115.58 2117.24V2105.05C2115.58 2104.5 2115.71 2103.99 2115.98 2103.53C2116.25 2103.06 2116.62 2102.69 2117.08 2102.42C2117.55 2102.15 2118.06 2102.01 2118.62 2102.01H2130.81C2131.36 2102.01 2131.87 2102.15 2132.33 2102.42C2132.8 2102.69 2133.17 2103.06 2133.44 2103.53C2133.71 2103.99 2133.85 2104.5 2133.85 2105.05V2117.24C2133.85 2117.8 2133.71 2118.31 2133.44 2118.78C2133.17 2119.24 2132.8 2119.61 2132.33 2119.88C2131.87 2120.15 2131.36 2120.28 2130.81 2120.28H2118.62ZM2118.62 2118.22H2130.81C2131.07 2118.22 2131.3 2118.12 2131.5 2117.93C2131.69 2117.73 2131.79 2117.5 2131.79 2117.24V2105.05C2131.79 2104.79 2131.69 2104.56 2131.5 2104.36C2131.3 2104.17 2131.07 2104.07 2130.81 2104.07H2118.62C2118.34 2104.07 2118.11 2104.17 2117.91 2104.36C2117.72 2104.56 2117.62 2104.79 2117.62 2105.05V2117.24C2117.62 2117.5 2117.72 2117.73 2117.91 2117.93C2118.11 2118.12 2118.34 2118.22 2118.62 2118.22Z"
            fill="white"
          />
        </svg>
      </div>
      <div
        className="loading"
        style={{
          position: "absolute",
          right: "64px",
          color: "rgba(218, 218, 218, 1.00)",
          fontFamily: "Orbitron",
          letterSpacing: "2px",
          fontWeight: 400,
        }}
      >
        {progress} %
      </div>
    </div>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(0);

  useEffect(() => {
    let progressCounter = 0;
    const interval = setInterval(() => {
      progressCounter += 10;
      if (progressCounter <= 100) {
        setLoadingProgress(progressCounter);
      } else {
        clearInterval(interval);
        setIsLoading(false);
      }
    }, 300); // Simulate loading progress every 300ms

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isLoading ? (
        <LoadingScreen progress={loadingProgress} />
      ) : (
        <LazyScroller />
      )}
    </>
  );
}

const LazyScroller = React.lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
